import {
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';

import { useQueryFilterNew } from '../common/use-query-param-new';

import type { TParseFunctions } from '../common/use-query-param-new';
import type { ISmsCampaignsFilters } from 'infrastructure/interfaces';

const defaultFilter: ISmsCampaignsFilters = {
  page: 1,
};

const parseFunctions: TParseFunctions<ISmsCampaignsFilters> = {
  page: parseSearchNumberValue,
  status: parseSearchStringValue,
};

export const useSmsCampaignsQueryFilter = () => {
  return useQueryFilterNew<ISmsCampaignsFilters>(
    defaultFilter,
    parseFunctions,
    [],
  );
};
